import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/text-click.ogg'
import _imports_1 from '@/assets/audio/text-click.mp3'
import _imports_2 from '@/assets/audio/quest-click.ogg'
import _imports_3 from '@/assets/audio/quest-click.mp3'
import _imports_4 from '@/assets/images/edit.svg'


const _withScopeId = n => (_pushScopeId("data-v-2575f938"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/ogg"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "audio/mp3"
}, null, -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_2,
  type: "audio/ogg"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_3,
  type: "audio/mp3"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "header" }
const _hoisted_8 = { class: "body" }
const _hoisted_9 = { class: "quest-selector" }
const _hoisted_10 = { class: "quest-selector-list" }
const _hoisted_11 = {
  key: 0,
  class: "quest-header"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "justify-between" }
const _hoisted_14 = { class: "cap-text" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "quest-details" }
const _hoisted_17 = { class: "flex-row" }
const _hoisted_18 = {
  key: 0,
  class: "quest-desc-name"
}
const _hoisted_19 = { class: "quest-description" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "quest-rewards" }
const _hoisted_22 = { class: "quest-reward-icons" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "quantity-text" }
const _hoisted_26 = { class: "flex-end save-buttons" }

import CloseButton from "../shared/CloseButton.vue";
import Quests from "@/state/Quests";
import { ItemDatabase } from "@/state/Gacha";
import { Item, ItemStringQuantity, Quest } from "@/types";
import ItemDescriptionOverlay from "../overlays/ItemDescriptionOverlay.vue";
import ItemObtainOverlay from "../overlays/ItemObtainOverlay.vue";
import CancelConfirmButton from "../shared/CancelConfirmButton.vue";
import Inventory from "@/state/Inventory";
import { computed, onMounted, Ref, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    inventory: null
  },
  emits: ["exit"],
  setup(__props: any, { emit }) {

const props = __props as { inventory: Inventory }



const active = ref(true);
const currentTab = ref("All Quests");
const quests = ref(new Quests());
const currentQuest = ref({} as Quest);
const itemDescriptionId = ref("");
const editMode = ref(false);
const obtainScreenRewards = ref([] as ItemStringQuantity[]);
const audioCancelConfirm: Ref<HTMLAudioElement | null> = ref(null);
const audioQuestClick: Ref<HTMLAudioElement | null> = ref(null);

const itemDescription = computed(() => ItemDatabase[itemDescriptionId.value]);
const formattedQuests = computed(() => [
  {
    name: "Commission Quests",
    quests: quests.value.commissions.filter((i) => !i.complete),
    icon: "./ui-commissions.png",
  },
  {
    name: "Event Quests",
    quests: quests.value.events.filter((i) => !i.complete),
  },
  {
    name: "Completed Quests",
    quests: [
      ...quests.value.commissions.filter((i) => i.complete),
      ...quests.value.events.filter((i) => i.complete),
    ],
  },
]);

function idToItem(id: string): Item {
  return ItemDatabase[id];
}

function exitAnimation() {
  active.value = false;
}
function exit() {
  if (!active.value) {
    emit("exit");
  }
}
function processClaim() {
  audioCancelConfirm.value?.play();
  if (editMode.value) {
    editMode.value = false;
    quests.value.saveState();
  } else {
    if (!currentQuest.value.complete) {
      if (currentQuest.value.rewards) {
        props.inventory.addItems(currentQuest.value.rewards);
      }
      // mark the current quest as done and save it
      obtainScreenRewards.value = currentQuest.value.rewards || [];
      currentQuest.value.complete = true;
      currentQuest.value.claimed = new Date();
      quests.value.refresh();

      // TODO: fix all of the divs bouncing around everywhere
      // by adding padding?
      // TODO: shrink the description buttons on click instead
      // of filtering brightness to emulate original behaviour
    }
  }
}
function deleteCurrentQuest() {
  audioCancelConfirm.value?.play();

  // commissions can't be deleted and ids should be unique
  quests.value.events.splice(
    quests.value.events.findIndex((i) => i.id === currentQuest.value.id),
    1
  );
  resetCurrentQuest();
  quests.value.saveState();
}
function setCurrentQuest(quest: Quest) {
  const audio = audioQuestClick;
  if (audio.value && !audio.value.paused) {
    audio.value.currentTime = 0;
  }
  audio.value?.play();
  currentQuest.value = quest;
  editMode.value = false;
}
function resetCurrentQuest() {
  editMode.value = false;
  currentQuest.value =
    formattedQuests.value.find((i) => i.quests.length > 0)?.quests[0] ||
    quests.value.commissions[0];
}
function newQuest() {
  const audio = audioQuestClick;
  if (audio.value && !audio.value.paused) {
    audio.value.currentTime = 0;
  }
  audio.value?.play();
  quests.value.events.push({
    name: "New Quest",
    id: `custom-event-${+new Date()}`,
    description: "Add an interesting description here!",
    rewards: [{ id: "primogem", quantity: 900 }],
  });
  currentQuest.value = quests.value.events[quests.value.events.length - 1];
}

const icons = (path: string) => {
  const i = require.context("@/assets/images/", false);
  try {
    return i(path);
  } catch (err) {
    console.log(`Could not find ${path}.`);
    return path;
  }
};

onMounted(() => {
  resetCurrentQuest();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (itemDescriptionId.value)
      ? (_openBlock(), _createBlock(ItemDescriptionOverlay, {
          key: 0,
          item: _unref(itemDescription),
          onExit: _cache[0] || (_cache[0] = ($event: any) => (itemDescriptionId.value = ''))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (obtainScreenRewards.value.length > 0)
      ? (_openBlock(), _createBlock(ItemObtainOverlay, {
          key: 1,
          "obtained-items": obtainScreenRewards.value,
          onExit: _cache[1] || (_cache[1] = ($event: any) => (obtainScreenRewards.value = []))
        }, null, 8, ["obtained-items"]))
      : _createCommentVNode("", true),
    _createElementVNode("audio", {
      ref_key: "audioCancelConfirm",
      ref: audioCancelConfirm,
      preload: "auto"
    }, _hoisted_3, 512),
    _createElementVNode("audio", {
      ref_key: "audioQuestClick",
      ref: audioQuestClick,
      preload: "auto"
    }, _hoisted_6, 512),
    _createElementVNode("div", {
      class: _normalizeClass({ main: true, 'exit-main': !active.value }),
      onAnimationend: exit
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, _toDisplayString(currentTab.value), 1),
        _createVNode(CloseButton, { onClicked: exitAnimation })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formattedQuests), (category, _) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: _ }, [
                (currentTab.value === 'All Quests' && category.quests.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(category.name), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.quests, (quest) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: quest.id
                  }, [
                    (
                  currentTab.value === 'All Quests' || currentTab.value === category.name
                )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass({
                  'quest-box': true,
                  'quest-box-active': currentQuest.value.id === quest.id,
                  'quest-box-faded': quest.complete,
                }),
                          onClick: ($event: any) => (setCurrentQuest(quest))
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(quest.name), 1),
                            (category.icon)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: icons(category.icon)
                                }, null, 8, _hoisted_15))
                              : _createCommentVNode("", true)
                          ])
                        ], 10, _hoisted_12))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            (!editMode.value)
              ? (_openBlock(), _createBlock(CancelConfirmButton, {
                  key: 0,
                  text: "New",
                  invert: "",
                  onPressed: newQuest
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (!editMode.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(currentQuest.value.name), 1))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentQuest.value.name) = $event)),
                  type: "text",
                  class: "quest-desc-name",
                  maxlength: "40"
                }, null, 512)), [
                  [_vModelText, currentQuest.value.name]
                ]),
            (!currentQuest.value.uneditable)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  class: "ui-icon",
                  src: _imports_4,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (editMode.value = !editMode.value))
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (!editMode.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(currentQuest.value.description), 1))
              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 1,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentQuest.value.description) = $event)),
                  class: "quest-description"
                }, null, 512)), [
                  [_vModelText, currentQuest.value.description]
                ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", {
              class: _normalizeClass({ 'quest-header': true, 'quest-header-white': editMode.value })
            }, " Quest Chain Rewards: ", 2),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuest.value.rewards, (i, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass([
                'reward-icon-graphics',
                [0, 'gray', 'green', 'blue', 'purple', 'orange'][
                  idToItem(i.id).rarity
                ],
              ]),
                  onClick: ($event: any) => (itemDescriptionId.value = i.id)
                }, [
                  _createElementVNode("img", {
                    src: require(`@/assets/images/${i.id}.webp`),
                    class: "icon-img"
                  }, null, 8, _hoisted_24),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(i.quantity), 1)
                ], 10, _hoisted_23))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            (editMode.value || !currentQuest.value.complete)
              ? (_openBlock(), _createBlock(CancelConfirmButton, {
                  key: 0,
                  text: editMode.value ? 'Save' : 'Claim',
                  invert: "",
                  onPressed: processClaim
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            (currentQuest.value.id && !currentQuest.value.id.startsWith('root-'))
              ? (_openBlock(), _createBlock(CancelConfirmButton, {
                  key: 1,
                  text: "Delete",
                  invert: "",
                  onPressed: deleteCurrentQuest
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 34)
  ], 64))
}
}

})